import { flow, O, s, t } from '@packages/prelude'

// Trim, then treat the empty string as absence.
export const nonBlank: (value: string) => O.Option<t.NonEmptyString> = flow(s.trim, t.NonEmptyString.decode, O.fromEither)
